import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { DataTableHeader } from "vuetify";
import { UserMaster } from "@/models/user-master/UserMasterResponse";
import UserMasterEdit from "./UserMasterEdit.vue";
import { ValidState, Zaikbn } from "@/models/enum/Enum";
import ZaikbnChip from "./ZaikbnChip.vue";
import ValidChip from "./ValidChip.vue";
import { useApi } from "@/plugins/api/api";
import { useConfirm } from "@/plugins/confirm/confirm";
import { useAlert } from "@/plugins/alert/alert";
import UserRetireDialog from "./UserRetireDialog.vue";

type Props = {
  items: UserMaster[];
};
type Emits = {
  (e: "submit"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserMasterTable',
  props: {
    items: null
  },
  emits: ["submit"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "submit"): void;
}), expose: any, slots: any, attrs: any }) {

const { Paths, $post } = useApi();
const { $confirm } = useConfirm();
const { $alert } = useAlert();

const itemKey = "userId";

const headers: DataTableHeader[] = [
  { text: "社員コード", value: "userCode", divider: true, width: "115" },
  { text: "社員名", value: "userName", divider: true },
  { text: "所属コード", value: "affiliationCode", divider: true, width: "115" },
  { text: "所属", value: "affiliationName", divider: true },
  { text: "在籍区分", value: "zaikbn", divider: true, width: "100" },
  { text: "権限", value: "authName", divider: true, width: "150" },
  { text: "状態", value: "valid", divider: true, width: "80" },
  { text: "操作", value: "menu", align: "center", sortable: false, width: "60" }
];




const search = ref("");

const isOpen = ref(false);
const userId = ref<number>();

const onEdit = (val: UserMaster) => {
  userId.value = val.userId;
  isOpen.value = true;
};

const onValid = async (val: UserMaster) => {
  const confirm = await $confirm("有効にします。\nよろしいですか？");
  if (confirm) {
    const reuslt = await $post(`${Paths.userMaster.info.valid}/${val.userId}`);
    if (reuslt) {
      $alert("success", "有効にしました。");
      emits("submit");
    }
  }
};
const onInvalid = async (val: UserMaster) => {
  const confirm = await $confirm("無効にします。\nよろしいですか？");
  if (confirm) {
    const reuslt = await $post(
      `${Paths.userMaster.info.invalid}/${val.userId}`
    );
    if (reuslt) {
      $alert("success", "無効にしました。");
      emits("submit");
    }
  }
};
const onUnRetire = async (val: UserMaster) => {
  const confirm = await $confirm("退職の取消をします。\nよろしいですか？");
  if (confirm) {
    const date = "9999-12-31";
    const reuslt = await $post(
      `${Paths.userMaster.info.unretire}/${val.userId}/${date}`
    );
    if (reuslt) {
      $alert("success", "退職の取消をしました。");
      emits("submit");
    }
  }
};

const onRetire = () => {
  emits("submit");
};

const isValid = (val: UserMaster) => {
  return ValidState.Valid === val.valid;
};
const isInValid = (val: UserMaster) => {
  return ValidState.InValid === val.valid;
};
const isRetire = (val: UserMaster) => {
  return Zaikbn.TAI === val.zaikbn;
};

return { __sfc: true,Paths, $post, $confirm, $alert, itemKey, headers, emits, search, isOpen, userId, onEdit, onValid, onInvalid, onUnRetire, onRetire, isValid, isInValid, isRetire, UserMasterEdit, ZaikbnChip, ValidChip, UserRetireDialog }
}

})